export const REPLY_WINDOW_DAYS = 30;
/** The start of tomorrow, local to whoever is asking — "for today" ends at midnight. */
function startOfTomorrow(now) {
    const next = new Date(now);
    next.setHours(24, 0, 0, 0);
    return next.toISOString();
}
export function inboxLenses(now = new Date()) {
    const since = new Date(now.getTime() - REPLY_WINDOW_DAYS * 86_400_000).toISOString();
    return [
        {
            id: "waiting",
            label: "Waiting on us",
            hint: `They wrote, what they said asks for an answer, and we have not sent one. The last ${REPLY_WINDOW_DAYS} days.`,
            empty: "Nobody is waiting on an answer.",
            where: {
                kind: ["==", "person"],
                status: ["==", "open"],
                needs_reply: ["==", true],
                last_message_at: [">=", since]
            }
        },
        {
            id: "unread",
            label: "Unread",
            hint: "Conversations with something new you have not opened.",
            empty: "Nothing unread.",
            where: { kind: ["==", "person"], status: ["==", "open"], unread: ["==", true] }
        },
        {
            id: "today",
            label: "For today",
            hint: "Conversations somebody set to look at again today, or earlier and not yet done.",
            empty: "Nothing to pick up today.",
            where: { kind: ["==", "person"], status: ["==", "open"], follow_up_at: ["<", startOfTomorrow(now)] }
        },
        {
            id: "unlinked",
            label: "Not linked",
            hint: "We do not know which person or company these are with. Link them from the conversation.",
            empty: "Every conversation is linked to someone.",
            where: {
                kind: ["==", "person"],
                status: ["==", "open"],
                prospectId: ["is-null", null],
                companyId: ["is-null", null]
            }
        },
        {
            id: "all",
            label: "All",
            hint: "Every open conversation with a person, answered or not. Pitches, invoices and notifications are under Filtered.",
            empty: "No conversations yet.",
            where: { kind: ["==", "person"], status: ["==", "open"] }
        },
        {
            id: "machines",
            label: "Filtered",
            hint: "Everything that is not a conversation: cold pitches, invoices, notifications, newsletters, bounces and senders you silenced. Kept, and counted nowhere.",
            empty: "Nothing filtered.",
            where: { kind: ["!=", "person"], status: ["==", "open"] }
        },
        {
            id: "archived",
            label: "Archived",
            hint: "Archived here. In the mailbox itself they are where they always were.",
            empty: "Nothing archived.",
            where: { status: ["==", "closed"] }
        }
    ];
}
export function inboxLens(id, now = new Date()) {
    return inboxLenses(now).find(lens => lens.id === id);
}
/** A lens narrowed to one mailbox, or left across all of them. */
export function lensWhere(id, mailboxId, now = new Date()) {
    const where = { ...inboxLens(id, now).where };
    if (mailboxId)
        where.mailboxId = ["==", mailboxId];
    return where;
}
/**
 * The inbox screen's own URL. `/inbox` is the app view; these parameters pick
 * the tab, the mailbox and the open conversation, and are how the brief, a
 * person's page and a timeline row point into it.
 */
export function inboxPath(params = {}) {
    const query = new URLSearchParams();
    if (params.lens)
        query.set("lens", params.lens);
    if (params.mailbox)
        query.set("mailbox", params.mailbox);
    if (params.thread)
        query.set("thread", params.thread);
    if (params.to)
        query.set("to", params.to);
    if (params.subject)
        query.set("subject", params.subject);
    const text = query.toString();
    return text ? `/inbox?${text}` : "/inbox";
}
